// Gesto del panel inferior, como en las apps de mapas: deslizar hacia abajo lo pliega y hacia
// arriba lo despliega. El panel sigue al dedo mientras se arrastra. Si la lista de dentro está
// desplazada, deslizar hacia abajo la desplaza primero; solo pliega estando arriba del todo.

const START_PX = 8; // movimiento mínimo para decidir que es un arrastre vertical
const FOLD_PX = 60; // arrastre que pliega o despliega al soltar

export function enableSheetDrag(sheet: HTMLElement, scroller: HTMLElement): void {
  let x0 = 0;
  let y0 = 0;
  let dragging = false;
  let decided = false;

  sheet.addEventListener(
    "touchstart",
    (e) => {
      const t = e.touches[0];
      if (!t || e.touches.length > 1) return;
      x0 = t.clientX;
      y0 = t.clientY;
      dragging = false;
      decided = false;
    },
    { passive: true },
  );

  sheet.addEventListener(
    "touchmove",
    (e) => {
      const t = e.touches[0];
      if (!t) return;
      const dx = t.clientX - x0;
      const dy = t.clientY - y0;
      const min = sheet.classList.contains("min");
      if (!decided) {
        if (Math.abs(dx) < START_PX && Math.abs(dy) < START_PX) return;
        decided = true;
        // Solo arrastres verticales (los chips se desplazan en horizontal), en el sentido que
        // cambia algo y sin robarle el gesto a la lista si no está arriba del todo.
        const inList = scroller.contains(e.target as Node);
        dragging =
          Math.abs(dy) > Math.abs(dx) &&
          (min ? dy < 0 : dy > 0 && (!inList || scroller.scrollTop <= 0));
        if (dragging) sheet.style.transition = "none";
      }
      if (!dragging) return;
      e.preventDefault();
      // Desplegado: baja con el dedo. Plegado: sube desde su sitio (transform de .min).
      sheet.style.transform = min
        ? `translateY(calc(100% - 104px + ${Math.min(0, dy)}px))`
        : `translateY(${Math.max(0, dy)}px)`;
    },
    { passive: false },
  );

  const end = (e: TouchEvent): void => {
    if (!dragging) return;
    dragging = false;
    const t = e.changedTouches[0];
    const dy = t ? t.clientY - y0 : 0;
    sheet.style.transition = "";
    sheet.style.transform = "";
    if (sheet.classList.contains("min")) {
      if (dy < -FOLD_PX / 2) sheet.classList.remove("min");
    } else if (dy > FOLD_PX) {
      sheet.classList.add("min");
    }
  };
  sheet.addEventListener("touchend", end);
  sheet.addEventListener("touchcancel", end);
}
